export default "__VITE_ASSET__C3gX6GJA__"